import CoreTrendsBarCell from "pro-features/components/core cells/src/CoreTrendsBarCell/CoreTrendsBarCell";
import { i18nFilter } from "app/filters/i18nFilter";

import {
    CountryCell,
    DefaultCell,
    DefaultCellRightAlign,
    IndexCell,
    RelevancyCell,
} from "../../../../../../components/React/Table/cells";
import {
    DefaultCellHeaderRightAlign,
    DefaultEllipsisHeaderCell,
    HeaderCellBlank,
} from "../../../../../../components/React/Table/headerCells";

const DEFAULT_SORT_DIRECTION = "desc";
const scoreDotsAmount = 5;

export const YoutubeKeywordGeneratorRelatedColumnsConfig = {
    getColumns: (hasScore: boolean, sortedColumn, isAscending) => {
        return [
            {
                fixed: true,
                cellComponent: IndexCell,
                headerComponent: HeaderCellBlank,
                disableHeaderCellHover: true,
                sortable: false,
                isResizable: false,
                width: 65,
            },
            {
                fixed: true,
                field: "keyword",
                sortable: true,
                showTotalCount: true,
                cellComponent: DefaultCell,
                displayName: i18nFilter()("youtube.keyword.generator.table.column.keyword"),
                tooltip: i18nFilter()("youtube.keyword.generator.table.column.keyword.tooltip"),
                width: 294,
            },
            hasScore && {
                field: "score",
                sortable: true,

                cellComponent: (props) => (
                    <RelevancyCell
                        {...props}
                        value={Math.ceil(props.value * scoreDotsAmount)}
                    />
                ),
                displayName: i18nFilter()("youtube.keyword.generator.table.column.score"),
                tooltip: i18nFilter()("youtube.keyword.generator.table.column.score.tooltip"),
                width: 144,
            },
            {
                field: "volume",
                sortable: true,
                displayName: i18nFilter()("youtube.keyword.generator.table.column.volume"),
                tooltip: i18nFilter()("youtube.keyword.generator.table.column.volume.tooltip"),
                cellComponent: DefaultCellRightAlign,
                headerComponent: DefaultCellHeaderRightAlign,
                format: "swPosition",
                width: 115,
            },
            {
                field: "volumeTrend",
                displayName: i18nFilter()("youtube.keyword.generator.table.column.volumetrend"),
                tooltip: i18nFilter()("youtube.keyword.generator.table.column.volumetrend.tooltip"),
                cellComponent: ({ value }) => {
                    if (value) {
                        return <CoreTrendsBarCell value={value} />;
                    } else {
                        return "N/A";
                    }
                },
                format: "swPosition",
                width: 130,
                groupKey: "keywordGeneratorTool",
            },
            {
                field: "clicks",
                sortable: true,
                displayName: i18nFilter()("youtube.keyword.generator.table.table.column.clicks"),
                tooltip: i18nFilter()("youtube.keyword.generator.table.column.clicks.tooltip"),
                cellComponent: DefaultCellRightAlign,
                headerComponent: DefaultCellHeaderRightAlign,
                format: "swPosition",
                width: 100,
            },
            {
                field: "topCountry",
                displayName: i18nFilter()("youtube.keyword.generator.table.column.topCountry"),
                tooltip: i18nFilter()("youtube.keyword.generator.table.column.topCountry.tooltip"),
                cellComponent: CountryCell,
                minWidth: 180,
            },
        ]
            .filter(Boolean)
            .map((col: any) => {
                const isSorted = col.field === sortedColumn;
                const sortDirection = isAscending ? "asc" : "desc";
                return {
                    ...col,
                    visible: true,
                    headerComponent: DefaultEllipsisHeaderCell,
                    isSorted,
                    sortDirection: isSorted ? sortDirection : DEFAULT_SORT_DIRECTION,
                    isResizable: col.isResizable !== false,
                };
            });
    },
};
